import { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../context/auth/AuthContext";
import useTranslator from "../../../hooks/useTranslator";
import { getAccountName, haveValue, toast } from "../../../helper/common";
import EditProfileModal from "../../../components/EditProfileModal";
import {
  Avatar,
  Badge,
  Button,
  Card,
  Icon,
  InfoList,
  Modal,
  PasswordInput,
} from "../../../components/design";
import "./landlordProfile.css";

const LandLordProfile = () => {
  const { _t } = useTranslator();

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { user, changePassword } = authContext;
  const [changePasswordModal, setChangePasswordModal] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("usertype") !== "landlord") navigate("/");
  }, []);

  const defaultPassData = {
    new_password: "",
    confirm_password: "",
    type: localStorage.getItem("usertype"),
  };
  const [passData, setPassData] = useState(defaultPassData);
  const [pwdErrorMsg, setpwdErrorMsg] = useState("");
  const [passwordChangeLoading, setPasswordChangeLoading] = useState(false);

  const handlePassChange = (e) => {
    setPassData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setpwdErrorMsg("");
  };

  const strongPassword = new RegExp(
    "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
  );

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (passData.new_password === "" || passData.confirm_password === "") {
      setpwdErrorMsg(_t("pleaseEnterAllFields"));
    } else if (passData.new_password !== passData.confirm_password) {
      setpwdErrorMsg(_t("passwordNotMatches"));
    } else if (!strongPassword.test(passData.new_password)) {
      setpwdErrorMsg(
        _t("pleaseIncludeUppercaseLowercaseAndSpecialCharactersInYourPassword")
      );
    } else {
      setpwdErrorMsg("");
      setPasswordChangeLoading(true);
      changePassword(passData, user?._id)
        .then((res) => {
          console.log(res, "CHECK TEH VAL HERE");
          if (res) {
            toast.success(_t("Password Changed!"));
            setChangePasswordModal(false);
            setPassData(defaultPassData);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setPasswordChangeLoading(false);
        });
    }
  };

  const [showProfileModal, setShowProfileModal] = useState(false);

  const fullName = getAccountName(user);

  return (
    <>
      <div className="account-page">
        <header className="account-page__head">
          <h1>{_t("myProfile")}</h1>
          <p>{_t("myProfileSubtitle")}</p>
        </header>

        <Card className="account-hero">
          <Avatar name={fullName} size="xl" />
          <div className="account-hero__who">
            <div className="account-hero__name">
              <h2>{fullName}</h2>
              <Badge>{_t("landlord")}</Badge>
            </div>
            <p>{user?.email}</p>
          </div>
        </Card>

        <Card
          title={_t("personalDetails")}
          actions={
            <Button
              variant="secondary"
              iconStart={<Icon name="edit" size={16} />}
              onClick={() => setShowProfileModal(true)}
            >
              {_t("editProfile")}
            </Button>
          }
        >
          <InfoList
            emptyText={_t("notAdded")}
            items={[
              { label: _t("firstName"), value: user?.fname_companyName },
              { label: _t("lastName"), value: user?.lname },
              { label: _t("phoneNumber"), value: user?.phone },
              { label: _t("email"), value: user?.email },
              {
                label: _t("linkedInProfile"),
                value: user?.linkedin_profile,
              },
            ]}
          />
        </Card>

        <Card
          title={_t("password")}
          description={_t("passwordCardText")}
          actions={
            <Button
              variant="secondary"
              iconStart={<Icon name="lock" size={16} />}
              onClick={() => setChangePasswordModal(true)}
            >
              {_t("changePassword")}
            </Button>
          }
        />
      </div>

      <EditProfileModal
        show={showProfileModal}
        onClose={() => setShowProfileModal(false)}
      />

      <Modal
        open={changePasswordModal}
        onClose={() => setChangePasswordModal(false)}
        size="sm"
        align="start"
        title={_t("changePassword")}
      >
        <form className="account-password-form" onSubmit={handleChangePassword}>
          <PasswordInput
            name="new_password"
            label={_t("newPassword")}
            value={passData.new_password}
            onChange={handlePassChange}
            isShowChecks
          />
          <PasswordInput
            name="confirm_password"
            label={_t("reEnterNewPassword")}
            value={passData.confirm_password}
            onChange={handlePassChange}
          />
          {haveValue(pwdErrorMsg) && (
            <p className="account-password-error" role="alert">
              {pwdErrorMsg}
            </p>
          )}
          <Button type="submit" size="lg" block loading={passwordChangeLoading}>
            {_t("changePassword")}
          </Button>
        </form>
      </Modal>
    </>
  );
};

export default LandLordProfile;
